import { render, staticRenderFns } from "./CategoryCallsDialog.vue?vue&type=template&id=6882383e&scoped=true&"
import script from "./CategoryCallsDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryCallsDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCallsDialog.vue?vue&type=style&index=0&id=6882383e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6882383e",
  null
  
)

export default component.exports